<section class="floor-plan">
  <div class="floor-plan__canvas">
    <div class="floor-plan__card card no-gutter" *ngFor="let room of rooms" [ngStyle]="getRoomStyle(room)" (click)="openSensor(room)">
      <div class="floor-plan__header">
        <span class="floor-plan__icon"><i class="pi pi-wifi"></i></span>
        <span class="floor-plan__title"><span translate>SENSORS.SENSOR</span> {{ room.properties?.square }}</span>
      </div>
      <div class="floor-plan__location">
        <i class="pi pi-map-marker"></i>
        <span>{{ room.properties?.name }}</span>
      </div>

      <ng-container *ngIf="getRoomSensor(room) as sensor; else noSensor">
        <div class="floor-plan__time">
          <i class="pi pi-clock"></i>
          <span>{{ sensor.timestamp | date:'dd MMM yyyy H:mm' }}</span>
        </div>
        <div class="floor-plan__stats">
          <div class="floor-plan__stat">
            <div class="floor-plan__value">{{ sensor.temperature }} °C</div>
            <div class="floor-plan__label" translate>SENSORS.TEMPERATURE</div>
          </div>
          <div class="floor-plan__stat">
            <div class="floor-plan__value">{{ sensor.humidity }} %</div>
            <div class="floor-plan__label" translate>SENSORS.HUMIDITY</div>
          </div>
          <div class="floor-plan__stat">
            <div class="floor-plan__value floor-plan__battery" [ngClass]="getBatteryStatusClass(sensor)">{{ getBatteryPercent(sensor) }} %</div>
            <div class="floor-plan__label" translate>SENSORS.BATTERY</div>
          </div>
        </div>
      </ng-container>
      <ng-template #noSensor>
        <div class="floor-plan__time">
          <i class="pi pi-clock"></i>
          <span>{{ loading ? 'Loading...' : 'No data' }}</span>
        </div>
        <div class="floor-plan__stats">
          <div class="floor-plan__stat">
            <div class="floor-plan__value">{{ loading ? '...' : '-' }}</div>
            <div class="floor-plan__label" translate>SENSORS.TEMPERATURE</div>
          </div>
          <div class="floor-plan__stat">
            <div class="floor-plan__value">{{ loading ? '...' : '-' }}</div>
            <div class="floor-plan__label" translate>SENSORS.HUMIDITY</div>
          </div>
          <div class="floor-plan__stat">
            <div class="floor-plan__value">{{ loading ? '...' : '-' }}</div>
            <div class="floor-plan__label" translate>SENSORS.BATTERY</div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</section>
